import { SelectType } from './selectType';

export enum YesOrNoType {
  Yes = 'Yes',
  No = 'No',
}

export type YesOrNoSelectType = SelectType<YesOrNoType>;
